import uuid from '@vend/vend-uuid'
import { PromotionLineItem } from '../components/sale/sale-promotion/sale-promotion-resource'

type PromotionInput = Partial<Promotion> & {
  blazePromotion?: PromotionLineItem
}
export interface PromotionDetails {
  amount: number
  description: string | null
  id: string | null
  name: string | null
  promoCode: string | null
  promoCodeId: string | null
}

/**
 * Represents a promotion applied to a sale or line item.
 */
export class Promotion {
  /**
   * The unique ID of this Promotion locally generated on the client.
   *
   * @type UUID
   */
  public localId: string
  public id: string | null
  public priceBook:
    | {
        id: string
        name: string | null
      }
    | null
    | undefined

  public lineItemPromotion: PromotionLineItem | null | undefined
  public promotionDetails: PromotionDetails[] | null | undefined

  /**
   * @param data {Object}
   *      Object with properties and overrides to set on the new promotion
   */
  constructor(data: PromotionInput = {}) {
    this.localId = data.localId || uuid()
    this.id = data.id || null
    this.priceBook = data.priceBook

    // Model property rename, catering for existing indexedDB entries under blazePromotion
    this.lineItemPromotion = data.lineItemPromotion || data.blazePromotion
    this.promotionDetails = data.promotionDetails
  }
}
